import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Price, PriceKind } from '@product/const';

@Component({
  selector: 'sd-product-price-available',
  standalone: true,
  templateUrl: './product-price-available.component.html',
  styleUrls: ['./product-price-available.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceAvailableComponent {
  @Input() prices: Price[];
  @Input() isRentProduct: boolean;
  @Input() hidePersonalTitle = false;

  get personalPrice(): Price | undefined {
    const personalPrice = this.prices.find(({ kind }) => kind === PriceKind.PERSONAL);

    if (!personalPrice || !personalPrice.value) {
      return undefined;
    }

    const regularPrice = this.regularPrice;

    if (regularPrice && regularPrice.value && personalPrice.value <= regularPrice.value) {
      return personalPrice;
    }

    return undefined;
  }

  get regularPrice(): Price | undefined {
    return this.prices.find(({ kind }) => kind === PriceKind.REGULAR);
  }

  get crossedPrice(): Price | undefined {
    return this.prices.find(({ kind }) => kind === PriceKind.CROSSED);
  }

  @HostBinding('class')
  get className(): 'personal' | 'crossed' | undefined {
    if (this.personalPrice) {
      return 'personal';
    }

    if (this.crossedPrice) {
      return 'crossed';
    }

    return undefined;
  }

  get mainPrice(): Price | undefined {
    return this.personalPrice || this.regularPrice;
  }

  get secondaryPrice(): Price | undefined {
    return this.personalPrice ? this.regularPrice : this.crossedPrice;
  }
}
